import { EditOutlined } from "@ant-design/icons";
import type { IntlShape } from "@formatjs/intl";
import type { Dispatch } from "@reduxjs/toolkit";
import { Button, Card, Descriptions, Flex } from "antd";
import { actions as routerActions } from "redux-router5";
import { CountryFlag } from "../../../common/components/CountryFlag.tsx";
import { PageTitleContainer } from "../../../common/components/PageTitle.tsx";
import type { SideloadedTurbineInfo } from "../../../features/turbine/turbineSlice.ts";
import { routeNames } from "../../common/routes.ts";
import type {
  Location,
  PaginatedturbineResultsSideloadList,
} from "../../generated-axios-client";
import { LocationTurbinesInfo } from "./Turbines.tsx";

type LocationViewRenderProps = {
  intl: IntlShape;
  location: Location;
  dispatch: Dispatch;
  turbines: PaginatedturbineResultsSideloadList;
  turbineSideload: SideloadedTurbineInfo | null;
};

export const LocationViewRender = ({
  intl,
  location,
  dispatch,
  turbines,
  turbineSideload,
}: LocationViewRenderProps) => (
  <PageTitleContainer
    title={location.name}
    extra={
      <Button
        type="primary"
        icon={<EditOutlined />}
        onClick={() =>
          dispatch(
            routerActions.navigateTo(routeNames.LOCATION_EDIT, { id: location.id })
          )
        }
      >
        {intl.formatMessage({ id: "location_edit_title" })}
      </Button>
    }
  >
    <Flex vertical gap="middle">
      <Card title={intl.formatMessage({ id: "location_section_details" })}>
        <Descriptions bordered column={2}>
          <Descriptions.Item label={intl.formatMessage({ id: "location_name" })}>
            {location.name}
          </Descriptions.Item>
          <Descriptions.Item label={intl.formatMessage({ id: "location_country" })}>
            <CountryFlag countryCode={location.country} />
          </Descriptions.Item>
          <Descriptions.Item
            label={intl.formatMessage({ id: "location_description" })}
            span={2}
          >
            {location.description}
          </Descriptions.Item>
        </Descriptions>
      </Card>
      <LocationTurbinesInfo
        intl={intl}
        turbines={turbines}
        turbineSideload={turbineSideload}
      />
    </Flex>
  </PageTitleContainer>
);
